import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react/jsx-no-bind */
import { useState, useMemo } from 'react';
import { useRequest } from 'ahooks';
// import $i18n from 'panda-i18n';
import useStore from '$src/utils/dateStore';
import { defaultDateRange } from '$src/const';
import { Menu, Box, CnButton } from '@alife/cn-ui';
import $i18n from 'panda-i18n';
import CommonDate from './common-date';
import Absolute from './common-date/absolute';
import './index.scss';
/**
 * date-dialog 组件 TODO
 * @param {*} props
 * @returns
 */
export default function DateDialog(props) {
    const dateEnum = defaultDateRange($i18n);
    const [commonVisible, setCommonVisible] = useState(false);
    const [absoluteVisible, setAbsoluteVisible] = useState(false);
    const [dates, setDates] = useState([]);
    const [menu, setMenu] = useState(dateEnum);
    const { add, get } = useStore('custom');
    function openAbsolute() {
        setAbsoluteVisible(true);
    }
    useRequest(async () => {
        try {
            const res = await get();
            if (res) {
                const { habitData } = res;
                const data = JSON.parse(habitData || '[]');
                setDates(data);
                renderMenu(data);
            }
        }
        catch (error) {
            console.log(error);
        }
    });
    const { run: renderMenu } = useRequest(async (data) => {
        const menus = data
            .map((item) => ({
            label: $i18n.get({
                id: 'ItemDateStartitemTimeStartToItemDateEnditemTimeEnd',
                dm: '{itemDateStart}{itemTimeStart}到{itemDateEnd}{itemTimeEnd}',
            }, {
                itemDateStart: item.dateStart,
                itemTimeStart: item.timeStart,
                itemDateEnd: item.dateEnd,
                itemTimeEnd: item.timeEnd,
            }),
            value: $i18n.get({
                id: 'ItemDateStartitemTimeStartToItemDateEnditemTimeEnd',
                dm: '{itemDateStart}{itemTimeStart}到{itemDateEnd}{itemTimeEnd}',
            }, {
                itemDateStart: item.dateStart,
                itemTimeStart: item.timeStart,
                itemDateEnd: item.dateEnd,
                itemTimeEnd: item.timeEnd,
            }),
        }))
            .concat(dateEnum);
        setMenu(menus);
    }, { manual: true });
    const footer = useMemo(() => {
        return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'divider' }), _jsxs(Box, { direction: 'row', spacing: 10, margin: 10, align: 'center', justify: 'end', children: [_jsx(CnButton, { type: 'primary', text: true, onClick: openAbsolute, children: $i18n.get({ id: 'SelectTime', dm: '选择时间' }) }), _jsx(CnButton, { onClick: () => setCommonVisible(true), type: 'primary', size: 'small', children: $i18n.get({ id: 'EditTime', dm: '编辑时间' }) })] })] }));
    }, []);
    function onCommonDateClose() {
        setCommonVisible(false);
    }
    function onAbsoluteClose() {
        props.closeDropdown && props.closeDropdown();
        setAbsoluteVisible(false);
    }
    function onSelect(item) {
        props.onChange([item.value], [item.label]);
        props.closeDropdown && props.closeDropdown();
    }
    async function onSave(dates) {
        await add(dates);
        renderMenu(dates);
    }
    return (_jsxs("div", { className: 'date-dialog', children: [_jsx(Absolute, { visible: absoluteVisible, onVisibleChange: onAbsoluteClose, onChange: props.onChange, value: props.value, isDate: props?.isDate }), _jsx(Menu, { footer: footer, children: menu.map((item) => (_jsx(Menu.Item, { onClick: () => onSelect(item), children: item.label }, item.value))) }), _jsx(CommonDate, { onChange: props.onChange, visible: commonVisible, onClose: onCommonDateClose, onSave: onSave, dates: dates })] }));
}
